module.exports = __webpack_public_path__ + "static/media/Box with Mobile 4 Sets.541df4ff.png";